export interface FaqItem {
  q: string;
  a: string;
}

export const faq: FaqItem[] = [
  {
    q: "追更之前，为什么建议先补「人物关系课」？",
    a: "《师兄啊师兄》的看点一半在剧情推进，一半在人物关系的变化。师兄关系的亲疏、师姐互动的名场面、同门情谊的暗线，往往在前期一两句话里就埋下伏笔。先厘清人物关系，再看剧情，很多名场面和反转才能真正看懂，观感会完全不同。",
  },
  {
    q: "师兄关系有哪些主线组合？",
    a: "主要包括三组：大师兄与小师弟「长兄如父」式的守护线，二师兄与大师兄默契互补的搭档线，以及与对家魔修的亦敌亦友纠葛线。每条线的亲疏变化都对应着重要的剧情节点。",
  },
  {
    q: "师姐互动名场面一般出现在哪些情节？",
    a: "师姐互动名场面多集中在任务并肩、危机救场、日常拌嘴三类场景。大师姐与大师兄的欢喜冤家式互动、大师姐与三师姐的冷热互补配合，是其中最常被读者截图收藏的部分。",
  },
  {
    q: "同门情谊暗线指的是什么？",
    a: "除了明面上的温馨师门日常，云隐峰内部还藏着若干暗线——外门师妹云渺的身世、掌门玄真子的暗中布局、魔修与云隐峰的旧怨等。这些暗线让「护短」的同门情谊之下，多了一层更深的因果与张力。",
  },
  {
    q: "CP 线内容与正片剧情是什么关系？",
    a: "本站在整理 CP 线时，会严格依据正片已展现的互动与脉络梳理角色关系，属于粉丝向的内容整理与盘点，方便读者按线回看名场面，不代表官方设定。具体以作品原作为准。",
  },
  {
    q: "师门日常板块更新频率如何？",
    a: "师门日常板块会随剧情更新持续整理，收录云隐峰弟子们的日常片段、名场面与暖心细节，方便读者快速回顾与收藏。新内容会标注日期，旧片段也可按标签回溯。",
  },
];